import { render, staticRenderFns } from "./SearchPlugin.vue?vue&type=template&id=7735c4c7&"
import script from "./SearchPlugin.vue?vue&type=script&lang=js&"
export * from "./SearchPlugin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports